function detectDevice(): string {
  const device = navigator.userAgent.toLowerCase();

  if (
    /mobile|android|iphone|ipad|tablet/.test(device) ||
    (device.includes('macintosh') && 'ontouchstart' in window)
  ) {
    return 'Mobile/IPad';
  }
  if (/macintosh|windows|linux/.test(device)) {
    return 'Laptop/Desktop';
  }
  return 'Laptop/Desktop';
}

export default detectDevice;
